import './Hero.scss';

function Hero() {
  return (
    <div className="hero">
      <div>
        <h1 className="trajan">Dignity</h1>
        <p>Learn how The Salvation Army is championing the human dignity of those it serves.</p>
      </div>
    </div>
  );
}

export default Hero;
